module.exports = __webpack_public_path__ + "static/media/lastActive.e1e326de.svg";